module.exports = __webpack_public_path__ + "static/assets/23a3f5e51d210559593ed581bee6a4f4.svg";